import axios from '@utils/axios';

const viewTemplateCategory = {
  state: {
    templateCategoryId: 0,
    name: '',
    nameEn: '',
    description: '',
    descriptionEn: '',
    parentCategory: '',
    updatedAt: '',
    updatedBy: '',
    subCategory: false,
    references: ''
  },
  mutations: {
    setTemplateCategoryId(state, id) {
      state.templateCategoryId = id;
    },
    setName(state, name) {
      state.name = name;
    },
    setNameEn(state, nameEn) {
      state.nameEn = nameEn;
    },
    setDescription(state, description) {
      state.description = description;
    },
    setDescriptionEn(state, descriptionEn) {
      state.descriptionEn = descriptionEn;
    },
    setParentCategory(state, category) {
      state.parentCategory = category;
    },
    setSubcategory(state, sub) {
      state.subCategory = sub;
    },
    setUpdatedAt(state, at) {
      state.updatedAt = at;
    },
    setUpdatedBy(state, by) {
      state.updatedBy = by;
    },
    setReferences(state, references) {
      state.references = references;
    }
  },
  actions: {
    fetchTemplateCategory(context) {
      return axios.get('admin/templatecategories/getcategory', { params: {
        TemplateCategoryId: context.state.templateCategoryId
      } }).then((res) => {
        context.commit('setName', res.data.result.name);
        context.commit('setNameEn', res.data.result.nameEn);
        context.commit('setDescription', res.data.result.description);
        context.commit('setDescriptionEn', res.data.result.descriptionEn);
        context.commit('setParentCategory', res.data.result.parentCategory);
        context.commit('setSubcategory', res.data.result.subcategory);
        context.commit('setUpdatedAt', res.data.result.updatedAt);
        context.commit('setUpdatedBy', res.data.result.updatedBy);
        context.commit('setReferences', res.data.result.references);
      });
    },
  },
  namespaced: true
};

export default viewTemplateCategory;
